'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconUnlock, iconUnlockTag } from '@ni/nimble-components/dist/esm/icons/unlock';
import { wrap } from '../../utilities/react-wrapper';

export type { IconUnlock };
export { iconUnlockTag };
export const NimbleIconUnlock = wrap(IconUnlock);